import { render, staticRenderFns } from "./ShotSummary.vue?vue&type=template&id=bf812740&scoped=true&"
import script from "./ShotSummary.vue?vue&type=script&lang=js&"
export * from "./ShotSummary.vue?vue&type=script&lang=js&"
import style0 from "./ShotSummary.vue?vue&type=style&index=0&id=bf812740&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf812740",
  null
  
)

export default component.exports